import { CdkColumnDef } from '@angular/cdk/table';
import { booleanAttribute, computed, Directive, inject, input } from '@angular/core';
import { SortDirective } from './sort.directive';
import { SortDirection } from './table.type';

const ARIA_SORT: Record<SortDirection, 'ascending' | 'descending' | null> = {
  asc: 'ascending',
  desc: 'descending',
  '': null,
};

@Directive({
  selector: 'th[appSortHeader]',
  host: {
    '[class.sortable]': '!sortDisabled()',
    '[attr.tabindex]': 'sortDisabled() ? null : 0',
    '[class.sorted]': "direction() !== ''",
    '[class.desc]': "direction() === 'desc'",
    '[attr.aria-sort]': 'ariaSort()',
    '(click)': 'toggle()',
    '(keydown.enter)': 'toggle()',
    '(keydown.space)': 'toggleByKey($event)',
  },
})
export class SortHeaderDirective {
  private sortDirective = inject(SortDirective);

  private columnDef = inject(CdkColumnDef, { optional: true });

  appSortHeader = input('');

  sortDisabled = input(false, { transform: booleanAttribute });

  private column = computed(() => this.appSortHeader() || this.columnDef?.name || '');

  protected direction = computed(() => (this.sortDisabled() ? '' : this.sortDirective.directionOf(this.column())));

  protected ariaSort = computed(() => ARIA_SORT[this.direction()]);

  protected toggle() {
    if (this.sortDisabled()) return;

    this.sortDirective.toggle(this.column());
  }

  protected toggleByKey(event: Event) {
    event.preventDefault();
    this.toggle();
  }
}
